import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import UserCard from '../../components/UserCard'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'

const Blacklisteds = () => {
    const [blacklist, setBlacklist] = useState([])
    const [page, setPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true)

    const { organization } = useParams()

    useEffect(() => {
        const fetchBlacklisteds = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/blacklist`, { params: { page } })
                if (response && response.data) {
                    const newUsers = response.data
                    setBlacklist(prev =>
                        page === 1 ? newUsers : [...prev, ...newUsers]
                    )
                    setHasMore(newUsers.length > 0)
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Failed to load users")
            } finally {
                setIsLoading(false)
            }
        }

        if (organization) {
            fetchBlacklisteds()
        }
    }, [page, organization])

    const whitelist = async (usr) => {
        try {
            const response = await api.patch(`/${organization}/blacklist`, { usr })
            if (response) {
                toast.success("User removed from blacklist")
                setBlacklist(prev => prev.filter(user => user._id !== usr._id))
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to remove user")
        }
    }

    const refresh = () => {
        setPage(1)
    }

    return (
        <div>
            <h3 className="page-header-title">{organization}</h3><span>Blacklist</span>
            {!isLoading && blacklist.length === 0 && (
                <p className="not-found-msg">No blacklisted users</p>
            )}
            <div className="user-list">
                <InfiniteScroll
                    dataLength={blacklist.length}
                    next={() => setPage(prev => prev + 1)}
                    hasMore={hasMore}
                    pullDownToRefresh={true}
                    refreshFunction={refresh}
                    loader={<Loader />}
                >

                    {
                        blacklist.length > 0 && blacklist.map((user) => (
                            <UserCard
                                key={user._id}
                                user={user}
                                onAction={() => whitelist(user)} // assuming UserCard accepts action props
                            />
                        ))
                    }
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default Blacklisteds
